module.exports = __webpack_public_path__ + "static/media/snowy.svg.cc907c35.png";